// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-477db301] .success-message {\n    --tw-text-opacity: 1;\n    color: rgb(253 252 252 / var(--tw-text-opacity))\n}", "",{"version":3,"sources":["webpack://./resources/js/components/newsletter-subscribe.vue"],"names":[],"mappings":"AAEI;IAAA,oBAAA;IAAA;AAAA","sourcesContent":["\n::v-deep .success-message {\n    @apply text-white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
